.category-pill-content{display:inline-block;width:55px;height:21px;border-radius:100px;padding:5px 12px;text-align:center}
/*# sourceMappingURL=category-pill.component-XBTIVWGY.css.map */
